import React from 'react';
import { Shield, Award, Globe, TrendingUp } from 'lucide-react';

const TrustSection = () => {
  const logos = [
    "Harvard University",
    "World Bank",
    "McKinsey & Company",
    "United Nations",
    "Brookings Institution",
    "RAND Corporation"
  ];

  const certifications = [
    { icon: Shield, text: "ISO 27001 Certified" },
    { icon: Award, text: "SOC 2 Type II" },
    { icon: Globe, text: "GDPR Compliant" },
    { icon: TrendingUp, text: "99.9% Uptime SLA" }
  ];

  return (
    <div className="py-16 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Trust Badge */}
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-slate-500 tracking-wider uppercase mb-8">
            Trusted by Leading Organizations Worldwide
          </p>
          
          {/* Client Logos Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center mb-12">
            {logos.map((logo, index) => (
              <div 
                key={index}
                className="flex items-center justify-center p-4 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
              >
                <div className="text-center">
                  <div className="w-full h-12 flex items-center justify-center">
                    <span className="text-slate-600 font-semibold text-sm">{logo}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {certifications.map((cert, index) => {
            const IconComponent = cert.icon;
            return (
              <div 
                key={index}
                className="flex items-center justify-center gap-2 p-4 bg-slate-50 rounded-lg border border-slate-200 hover:border-[#8B3A3A]/30 transition-all duration-300"
              >
                <IconComponent className="w-5 h-5 text-[#8B3A3A]" />
                <span className="text-sm font-medium text-slate-700">{cert.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrustSection;